import Icon from '../components/Icon.vue'

Icon.register({
  'charging-station': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M336 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H336C344.8 512 352 504.8 352 496V464C352 455.2 344.8 448 336 448zM544 128V80C544 71.2 536.8 64 528 64S512 71.2 512 80V128H480V80C480 71.2 472.8 64 464 64S448 71.2 448 80V128H432C423.2 128 416 135.2 416 144V176C416 211.8 439.6 241.7 472 251.9V370.4C472 384.4 462.5 397.3 448.7 399.6 431.2 402.5 416 389 416 372V344C416 295.4 376.6 256 328 256H320V64C320 28.6 291.4 0 256 0H96C60.6 0 32 28.6 32 64V416H320V304H328C350.1 304 368 321.9 368 344V368.6C368 408.3 396.9 443.8 436.4 447.6 481.7 452.1 520 416.4 520 372V251.9C552.4 241.7 576 211.8 576 176V144C576 135.2 568.8 128 560 128H544zM260.1 175.8L166.4 314.8C164.2 318.1 160.2 320 156 320 148.3 320 142.5 313.7 144.3 307.1L167.3 224H108C100.8 224 95.2 218.4 96.1 212.1L112.1 105.1C112.9 99.9 118 96 124 96H192C199.9 96 205.6 102.5 203.6 109.2L192 160H249.7C258.9 160 264.7 168.8 260.1 175.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/charging-station.js
// module id = Ud5Y
// module chunks = 144